export const INITIAL_FORM_DATA = {
  fpo_name: "",
  contact_person: "",
  mobile_no: "",
  number_of_farmers: "",
  total_acreage: "",
  crops: [],
  expected_crop_residue_kharif: "",
  expected_crop_residue_rabi: "",
  funding_source: "",
  state: "",
  district: "",
  post_office: "",
  pin_code: "",
  address_line1: "",
};

export const fundingSourceOptions = [
  { value: "Self", label: "Self" },
  { value: "Third Party", label: "Third Party" },
];

// Remove crops and post_office from FORM_FIELDS as they are rendered separately
export const FORM_FIELDS = [
  {
    name: "fpo_name",
    label: "FPO Name",
    type: "text",
    required: true,
    gridProps: { xs: 12, sm: 6 },
  },
  {
    name: "contact_person",
    label: "Contact Person",
    type: "text",
    required: true,
    gridProps: { xs: 12, sm: 6 },
  },
  {
    name: "mobile_no",
    label: "Mobile Number",
    type: "number",
    required: true,
    inputProps: { maxLength: 10 },
    gridProps: { xs: 12, sm: 6 },
  },
  {
    name: "number_of_farmers",
    label: "Number of Farmers",
    type: "number",
    required: true,
    inputProps: { min: 0 },
    gridProps: { xs: 12, sm: 6 },
  },
  {
    name: "total_acreage",
    label: "Approximate Total Acreage",
    type: "number",
    required: true,
    inputProps: { min: 0, step: "0.01" },
    gridProps: { xs: 12, sm: 6 },
  },
  {
    name: "funding_source",
    label: "Funding Source",
    type: "select",
    required: true,
    options: fundingSourceOptions,
    gridProps: { xs: 12, sm: 6 },
  },
  {
    name: "expected_crop_residue_kharif",
    label: "Expected Crop Residue Kharif (MT)",
    type: "number",
    required: true,
    inputProps: { min: 0, step: "0.01" },
    gridProps: { xs: 12, sm: 6 },
  },
  {
    name: "expected_crop_residue_rabi",
    label: "Expected Crop Residue Rabi (MT)",
    type: "number",
    required: true,
    inputProps: { min: 0, step: "0.01" },
    gridProps: { xs: 12, sm: 6 },
  },
  {
    name: "pin_code",
    label: "Pin Code",
    type: "number",
    required: true,
    inputProps: { maxLength: 6 },
    gridProps: { xs: 12 },
  },
  {
    name: "state",
    label: "State",
    type: "text",
    required: true,
    disabled: true,
    gridProps: { xs: 12, sm: 6 },
  },
  {
    name: "district",
    label: "District",
    type: "text",
    required: true,
    disabled: true,
    gridProps: { xs: 12, sm: 6 },
  },
  {
    name: "address_line1",
    label: "Additional Address Info",
    type: "textarea",
    required: true,
    multiline: true,
    rows: 4,
    gridProps: { xs: 12 },
  },
];
